import {fromPairs} from 'lodash-es';
import Vue, {VueConstructor} from 'vue';

export type VueOptions = ConstructorParameters<VueConstructor>[0];
type OptionsFactory = (element: Element) => Exclude<VueOptions, undefined>;

export class VueComponentInitializer {
    private readonly selector: string;
    private readonly componentConstructor: VueConstructor;
    private readonly additionalOptionsFactory: OptionsFactory | undefined;
    private readonly additionalRenderOptions: object;

    public constructor(
        selector: string,
        component: VueConstructor,
        additionalOptionsFactory?: OptionsFactory,
        additionalRenderOptions: object = {},
        ) {
        this.selector = selector;
        this.componentConstructor = component;
        this.additionalOptionsFactory = additionalOptionsFactory;
        this.additionalRenderOptions = additionalRenderOptions;
    }

    public initialize(container: HTMLElement): void {
        container.querySelectorAll(this.selector).forEach(element => {
            const prefix = ':';

            const propPairs = element.getAttributeNames()
                .map(attribute => attribute.startsWith(prefix)
                    ? [attribute.substr(prefix.length), JSON.parse(element.getAttribute(attribute) as string)]
                    : [attribute, element.getAttribute(attribute)]);

            const additionalOptions = this.additionalOptionsFactory === undefined
                ? {}
                : this.additionalOptionsFactory(element);

            const props = {...(additionalOptions.propsData || {}), ...fromPairs(propPairs)};

            // tslint:disable no-unused-expression
            new Vue({
                el: element,
                ...additionalOptions,
                propsData: props,
                render: h => h(this.componentConstructor, {...this.additionalRenderOptions, attrs: props}),
            });
        });
    }
}

